"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTheme = void 0;

var _Color = require("../Color");

var _canI = require("../canI");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var generateTypographyStyles = function generateTypographyStyles(typography) {
  var style = "";

  if (typography.css && typeof typography.css === "string") {
    style += typography.css;
  }

  if (typography.fonts && _typeof(typography.fonts) === "object") {
    Object.keys(typography.fonts).map(function (fontName) {
      if (_typeof(typography.fonts[fontName]) === "object") {
        if (typography.fonts[fontName].preset) style += "@import url('".concat(typography.fonts[fontName].preset, "');");else if (Array.isArray(typography.fonts[fontName].src)) {
          style += "@font-face {\n            font-family: '".concat(typography.fonts[fontName].alias ? typography.fonts[fontName].alias : fontName, "';\n            ").concat(typography.fonts[fontName].fontStyle ? "font-style:".concat(typography.fonts[fontName].fontStyle, ";") : "", "\n            ").concat(typography.fonts[fontName].fontWeight ? "font-weight:".concat(typography.fonts[fontName].fontWeight, ";") : "", "\n            ").concat(typography.fonts[fontName].fontDisplay ? "font-display:".concat(typography.fonts[fontName].fontDisplay, ";") : "", "\n            src:");
          typography.fonts[fontName].local && typography.fonts[fontName].local.forEach(function (local) {
            style += "local('".concat(local, "'),");
          });
          typography.fonts[fontName].src.forEach(function (fontSrc, index) {
            style += "url('".concat(fontSrc.url, "') format('").concat(fontSrc.format, "')").concat(index < typography.fonts[fontName].src.length - 1 ? "," : "");
          });
          style += "}";
        }
        style += ".fr-font-name-".concat(fontName.toLocaleLowerCase().replace(/ /g, "-"), "{font-family: '").concat(typography.fonts[fontName].alias ? typography.fonts[fontName].alias : fontName, "', 'sans-serif'}");
      }

      return fontName;
    });
  }

  return style;
};

var generateColorsVariable = function generateColorsVariable(colors) {
  var style = ":root {";
  Object.keys(colors).forEach(function (color) {
    var rgbColor = (0, _Color.hex2RGB)(colors[color]);
    style += "--".concat(color, ": ").concat(colors[color], ";");
    style += "--".concat(color, "-rgb: ").concat(rgbColor.r, ", ").concat(rgbColor.g, ", ").concat(rgbColor.b, ";");
  });
  style += "}";
  return style;
};

var generateStylesPalette = function generateStylesPalette(palette, item, i) {
  var hoverBgColor = item.color;
  var gradientTo = item.color;
  var gradientButtonToHover = item.color;
  var gradientButtonFromActive = item.color;
  var gradientButtonToActive = item.color;
  var gradientButtonTextActive = item.textColor;
  var hoverColor = item.textColor;
  var activeBgColor = item.color;
  var activeColor = item.textColor;
  if (palette[i + 2]) gradientTo = palette[i + 2].color;else if (palette[i - 2]) gradientTo = palette[i - 2].color;
  if (palette[i + 1]) gradientButtonToHover = palette[i + 1].color;else if (palette[i - 1]) gradientButtonToHover = palette[i - 1].color;
  if (palette[i + 2]) gradientButtonFromActive = palette[i + 2].color;else if (palette[i - 2]) gradientButtonFromActive = palette[i - 2].color;
  if (palette[i + 4]) gradientButtonToActive = palette[i + 4].color;else if (palette[i - 4]) gradientButtonToActive = palette[i - 4].color;
  if (palette[i + 4]) gradientButtonTextActive = palette[i + 4].textColor;else if (palette[i - 4]) gradientButtonTextActive = palette[i - 4].textColor;
  if (palette[i + 2]) hoverBgColor = palette[i + 2].color;else if (palette[i - 2]) hoverBgColor = palette[i - 2].color;
  if (palette[i + 2]) hoverColor = palette[i + 2].textColor;else if (palette[i - 2]) hoverColor = palette[i - 2].textColor;
  if (palette[i + 3]) activeBgColor = palette[i + 3].color;else if (palette[i - 3]) activeBgColor = palette[i - 3].color;
  if (palette[i + 3]) activeColor = palette[i + 3].textColor;else if (palette[i - 3]) activeColor = palette[i - 3].textColor;
  var styles = "\n  button.fr-btn-".concat(item.name, "{\n    background-color:").concat(item.color, ";\n    border-color:").concat(item.color, ";\n    color:").concat(item.textColor, " !important;\n  }\n  button.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):active,\n  button.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):focus,\n  button.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):hover{\n    background-color:").concat(hoverBgColor, ";\n    border-color:").concat(hoverBgColor, ";\n    color:").concat(hoverColor, "\n  }\n  button.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):active,\n  button.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled).fr-active,\n  button.fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled):active,\n  button.fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled).fr-active,\n  button.fr-show > .fr-btn-outline-").concat(item.name, ".fr-dropdown-toggle{\n    color: ").concat(activeColor, ";\n    background-color: ").concat(activeBgColor, ";\n    border-color: ").concat(activeBgColor, ";\n  }\n  .fr-border-").concat(item.name, "{border-color: ").concat(item.color, " !important;}\n  .fr-bg-").concat(item.name, "{background-color: ").concat(item.color, " !important;}\n  .gradient.fr-bg-").concat(item.name, ",fr-btn-outline-").concat(item.name, ":hover,\n  button.gradient.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled){\n    background-image: linear-gradient(to bottom,").concat(item.color, ",").concat(gradientTo, ");\n  }\n  button.gradient.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):focus,\n  button.gradient.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):hover,\n  button.gradient.fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled):focus,\n  button.gradient.fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled):hover{\n    background-image: linear-gradient(to bottom,").concat(item.color, ",").concat(gradientButtonToHover, ");\n    color: ").concat(item.textColor, ";\n  }\n  button.gradient.fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):active,\n  button.gradient.fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled):active{\n    background-image: linear-gradient(to bottom,").concat(gradientButtonFromActive, ",").concat(gradientButtonToActive, ");\n    color: ").concat(gradientButtonTextActive, ";\n  }\n  .fr-text-").concat(item.name, "{color: ").concat(item.color, " !important;}\n  .fr-btn-outline-").concat(item.name, "{\n    color: ").concat(item.color, ";\n    border-color: ").concat(item.color, ";\n  }\n  .fr-btn-outline-").concat(item.name, ":hover{\n    color: ").concat(item.textColor, ";\n    background-color: ").concat(item.color, ";\n    border-color: ").concat(item.color, ";\n  }\n  .fr-btn-outline-").concat(item.name, ".fr-disabled,\n  .fr-btn-outline-").concat(item.name, ":disabled{\n    color: ").concat(item.color, " !important;\n    background-color: transparent !important;\n    border-color: ").concat(item.color, " !important;\n  }\n  .fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled):active:focus,\n  .fr-btn-").concat(item.name, ":not(:disabled):not(.fr-disabled):active:focus,\n  .fr-btn-outline-").concat(item.name, ":not(:disabled):not(.fr-disabled).fr-active:focus,\n  .fr-show > .fr-btn-outline-").concat(item.name, ".fr-dropdown-toggle:focus{\n    box-shadow: 0 0 0 0.2rem ").concat((0, _Color.hexToRGBA)(item.color), ";\n  }\n  .fr-btn-").concat(item.name, ":focus, .fr-btn-outline-").concat(item.name, ":focus{\n    box-shadow: 0 0 0 0.2rem ").concat((0, _Color.hexToRGBA)(item.color), ";\n  }\n  .fr-component-hover-").concat(item.name, ":hover:not(.fr-row):not([class^=fr-col]):not(button)>*{\n    color:").concat(item.textColor, " !important;\n  }\n  .fr-component-hover-").concat(item.name, ":hover:not(button){\n    background-color:").concat(item.color, " !important;\n    border-color:").concat(hoverBgColor, " !important;\n  }\n  .fr-icon.fr-i-").concat(item.name, " path{\n    fill: ").concat(item.color, ";\n  }\n  .fr-btn-").concat(item.name, " .fr-icon path{\n    fill: ").concat(item.textColor, ";\n  }\n");
  return styles;
};

var initTheme = function initTheme(theme) {
  var generatedStyles = [];
  var themeToken = {
    palette: {},
    designTokens: theme.designTokens || {}
  };
  var outputFields = [];

  if (theme.config && theme.config.outputFields) {
    outputFields = theme.config.outputFields;
  }

  if (outputFields.includes("colors")) {
    themeToken.colors = theme.colors;
  }

  if (outputFields.includes("typography")) themeToken.typography = theme.typography;

  if (theme) {
    if (theme.typography) {
      generatedStyles.push(generateTypographyStyles(theme.typography));
    }

    if (theme.colors || theme.designTokens.colors) {
      var colors = Boolean(theme.colors) ? theme.colors : theme.designTokens.colors;
      generatedStyles.push(generateColorsVariable(colors));
      var themeColorsKeys = Object.keys(colors);

      for (var index = 0; index < themeColorsKeys.length; index += 1) {
        var colorName = themeColorsKeys[index];
        var colorValue = colors[themeColorsKeys[index]];

        if (colorValue !== "none") {
          (function () {
            // Adding base color to palette
            themeToken.palette["".concat(colorName)] = colorValue;
            var palette = (0, _Color.generatePalette)(colorValue, colorName);

            if (theme.config && theme.config.generatePalette) {
              palette.forEach(function (item, i) {
                // Adding color variations to the palette
                themeToken.palette["".concat(item.name)] = item.color; // Avoiding executing unnecessary code that is not needed in the SSR

                if ((0, _canI.canIExecuteClientCode)()) {
                  var styles = generateStylesPalette(palette, item, i);
                  generatedStyles.push(styles.replace(/\n. |\r/g, ""));
                }
              });
            } else {
              if ((0, _canI.canIExecuteClientCode)()) {
                var styles = generateStylesPalette(palette, {
                  color: colorValue,
                  name: colorName,
                  textColor: (0, _Color.getContrast)(colorValue)
                }, 11);
                generatedStyles.push(styles.replace(/\n. |\r/g, ""));
              }
            }
          })();
        }
      }

      if (colors.primary) {
        var primaryHover = (0, _Color.hexToRGBA)(colors.primary, 0.4);
        generatedStyles.push(".fr-focus:focus, .fr-form-control:focus, .fr-focus\\:focus{box-shadow: 0px 0px 0px 3.2px ".concat(primaryHover, ";outline: 0;}"));
      }
    }

    if ((0, _canI.canIExecuteClientCode)() && typeof document != "undefined") {
      var element = document.getElementById("frTheming");

      if (element) {
        element.innerHTML = generatedStyles.join(" ");
      } else {
        var themeStyleNode = "".concat(generatedStyles.join(" "));
        var body = document.body || document.getElementsByTagName("body")[0];
        var style = document.createElement("style");
        style.type = "text/css";
        style.id = "frTheming";

        if (style.styleSheet) {
          // This is required for IE8 and below.
          style.styleSheet.cssText = themeStyleNode;
        } else {
          style.appendChild(document.createTextNode(themeStyleNode));
        }

        body.appendChild(style);
      }
    }
  }

  return themeToken;
};

exports.initTheme = initTheme;